import { Play, PowerOff } from 'lucide-react';
import { I18n } from '@/i18n/I18n';
import { DESKTOP_INSTRUMENT_STATE } from '@/types/instrumentBridgeTypes';
import { ButtonParent } from '../buttons/ButtonParent';
import { LoadingSpinner } from '../LoadingSpinner';

/**
 * Start and stop an instrument.
 *
 * Copied from veriform-desktop's `RunningStateButton` (renderer/
 * RunningStateButton.tsx) so the control looks and behaves the same in both
 * apps. The only change is the state enum: desktop's `INSTRUMENT_STATE` is this
 * repository's `DESKTOP_INSTRUMENT_STATE`, which carries the same values.
 *
 * Errored shows Stop, not Start -- a provider that failed is still a provider
 * the engine is holding, and stopping it is what clears that.
 *
 * One difference: desktop passes a title to its LoadingSpinner, which this
 * repository's does not take. Nothing visible changes -- the button already
 * carries that title -- only the spinner's own hidden label, which reads
 * "Loading" here.
 */

export function RunningStateButton(props: {
  handleStop: () => void;
  handleStart: () => void;
  state?: DESKTOP_INSTRUMENT_STATE;
  disabled?: boolean;
  pending?: boolean;
}) {
  const { handleStop, handleStart, state, disabled, pending } = props;

  if (pending) {
    return (
      <ButtonParent style={{ minHeight: '32px' }} className='btn btn-primary' disabled title={I18n.get('connectingToInstrument')} onClick={() => {}}>
        <LoadingSpinner />
      </ButtonParent>
    );
  }

  if (state === DESKTOP_INSTRUMENT_STATE.RUNNING || state === DESKTOP_INSTRUMENT_STATE.ERROR) {
    return (
      <ButtonParent style={{ minHeight: '32px' }} className='fusa-btn-small-with-icon btn-blue-dark' disabled={disabled} title={I18n.get('stop')} onClick={() => handleStop()}>
        <PowerOff size={16} />
        {I18n.get('stop')}
      </ButtonParent>
    );
  }

  return (
    <ButtonParent style={{ minHeight: '32px' }} className='btn fusa-btn-small-with-icon btn-primary' disabled={disabled} title={I18n.get('start')} onClick={() => handleStart()}>
      <Play size={16} />
      {I18n.get('start')}
    </ButtonParent>
  );
}
